module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container full-width"
  }, [_vm._m(0), _vm._v(" "), _c('app-header'), _vm._v(" "), _c('side-info', {
    ref: "sideInfo",
    style: ([_vm.mainPaddingTop]),
    attrs: {
      "template": _vm.name
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "main",
    style: (_vm.mainPaddingTop)
  }, [_c('div', {
    staticClass: "fil-ariane"
  }, [_vm._v("Mon espace")]), _vm._v(" "), _c('h1', {
    staticClass: "page-title"
  }, [_vm._v("Accueil de mon espace"), _c('span', {
    style: (_vm.welcomeMessages['currentDiffusionTitle']),
    attrs: {
      "id": "diff-en-cours-title"
    }
  }, [_vm._v(" - ma diffusion en cours")])]), _vm._v(" "), _c('div', {
    staticClass: "main-content"
  }, [_c('div', {
    style: (_vm.welcomeMessages['noCreationYetDisplay']),
    attrs: {
      "id": "no-creation-yet"
    }
  }, [_c('p', {
    staticStyle: {
      "margin-bottom": "calc(100vh / (949 / 40))"
    }
  }, [_vm._v("\n          Vous vous connectez pour la première fois ?"), _c('br'), _vm._v("Consultez "), _c('router-link', {
    attrs: {
      "to": "/miscellanous/conseils-pratiques"
    }
  }, [_vm._v("nos conseils pratiques")]), _vm._v(" avant de créer votre premier message promotionnel ou informatif.\n        ")], 1), _vm._v(" "), _c('div', {
    staticClass: "warning-box"
  }, [_c('svg', {
    staticClass: "warning-box-icon",
    staticStyle: {
      "fill": "var(--error-primary-color)"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "9111 -944 57.608 43.621"
    }
  }, [_c('path', {
    staticClass: "a",
    attrs: {
      "d": "M33.731,8.189a1.415,1.415,0,0,0-1.121.6L5.185,50.022a1.2,1.2,0,0,0,1.19,1.789H61.231a1.2,1.2,0,0,0,1.19-1.789L35,8.787a1.415,1.415,0,0,0-1.125-.6Zm.072,3.582,25.05,37.653H8.754Zm-.74,9.941c-.557,0-1.006.33-1.006.74V38.016c0,.41.449.742,1.006.742h1.474c.557,0,1.006-.332,1.006-.742V22.453c0-.411-.449-.74-1.006-.74Zm.74,22.026a1.536,1.536,0,1,0,1.751,1.52,1.648,1.648,0,0,0-1.751-1.52Z",
      "transform": "translate(9106.001 -952.189)"
    }
  })]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-default btn-side-info",
    staticStyle: {
      "margin-top": "calc(100vw / (1920 / 40))"
    },
    attrs: {
      "to": "/app/creer-un-message",
      "id": "mentions-legales"
    }
  }, [_vm._v("\n          CRÉER MON PREMIER MESSAGE\n        ")])], 1), _vm._v(" "), _c('div', {
    style: (_vm.welcomeMessages['noCreationOnDisplay']),
    attrs: {
      "id": "no-creation-on"
    }
  }, [_c('p', {
    staticStyle: {
      "margin-bottom": "calc(100vh / (949 / 40))"
    }
  }, [_vm._v("\n          Vous n'avez aucun message en cours."), _c('br'), _vm._v("Consultez "), _c('router-link', {
    attrs: {
      "to": "/miscellanous/conseils-pratiques"
    }
  }, [_vm._v("nos conseils pratiques")]), _vm._v(" avant de créer votre message promotionnel ou informatif.\n        ")], 1), _vm._v(" "), _c('div', {
    staticClass: "warning-box"
  }, [_c('svg', {
    staticClass: "warning-box-icon",
    staticStyle: {
      "fill": "var(--error-primary-color)"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "9111 -944 57.608 43.621"
    }
  }, [_c('path', {
    staticClass: "a",
    attrs: {
      "d": "M33.731,8.189a1.415,1.415,0,0,0-1.121.6L5.185,50.022a1.2,1.2,0,0,0,1.19,1.789H61.231a1.2,1.2,0,0,0,1.19-1.789L35,8.787a1.415,1.415,0,0,0-1.125-.6Zm.072,3.582,25.05,37.653H8.754Zm-.74,9.941c-.557,0-1.006.33-1.006.74V38.016c0,.41.449.742,1.006.742h1.474c.557,0,1.006-.332,1.006-.742V22.453c0-.411-.449-.74-1.006-.74Zm.74,22.026a1.536,1.536,0,1,0,1.751,1.52,1.648,1.648,0,0,0-1.751-1.52Z",
      "transform": "translate(9106.001 -952.189)"
    }
  })]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-default btn-side-info",
    staticStyle: {
      "margin-top": "calc(100vw / (1920 / 40))"
    },
    attrs: {
      "to": "/app/creer-un-message"
    }
  }, [_vm._v("\n          CRÉER UN MESSAGE\n        ")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-default btn-side-info",
    staticStyle: {
      "margin-top": "calc(100vw / (1920 / 40))"
    },
    attrs: {
      "to": "/app/gerer-diffusion"
    }
  }, [_vm._v("\n          GÉRER MA DIFFUSION\n        ")])], 1), _vm._v(" "), _c('div', {
    style: (_vm.welcomeMessages['currentCreationsDisplay']),
    attrs: {
      "id": "current-creations"
    }
  }, [_c('div', {
    staticClass: "info-box-main-home"
  }, [_c('svg', {
    staticClass: "info-box-icon-main",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "8949 -947 14.89 50"
    }
  }, [_c('path', {
    staticClass: "a",
    attrs: {
      "d": "M30.19,997.365a2.5,2.5,0,1,0,2.5,2.5A2.5,2.5,0,0,0,30.19,997.365Zm0,16.541H22.56l.012,3,5.89-.021v27.5H22.556l.006,2.952,7.628.01,7.255.018-.006-2.97-5.519-.01v-27.5c0-2.991.046-2.987-1.73-2.987Z",
      "transform": "translate(8926.444 -1944.365)"
    }
  })]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('current-diffusion', {
    attrs: {
      "slotLimit": _vm.slotLimit,
      "editEnabled": _vm.editEnabled,
      "userProps": _vm.userProps,
      "overDropZone": _vm.overDropZone,
      "terminalMediaArr": _vm.terminalMediaArr,
      "currentDraggedImg": _vm.currentDraggedImg
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-default btn-side-info",
    staticStyle: {
      "margin-top": "calc(100vw / (1920 / 15))"
    },
    attrs: {
      "to": "/app/creer-un-message"
    }
  }, [_vm._v("\n          CRÉER UN MESSAGE\n        ")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-default btn-side-info",
    staticStyle: {
      "margin-top": "calc(100vw / (1920 / 15))"
    },
    attrs: {
      "to": "/app/gerer-diffusion"
    }
  }, [_vm._v("\n          GÉRER MA DIFFUSION\n        ")])], 1)])]), _vm._v(" "), _c('app-footer'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-lg",
    staticStyle: {
      "visibility": "hidden"
    },
    attrs: {
      "id": "modalButton",
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#errModal"
    }
  }, [_vm._v("\n    Launch modal\n  ")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "errModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-title",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "arrow",
    staticStyle: {
      "margin-left": "0"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "h2-arrow",
    staticStyle: {
      "padding": "0"
    }
  }, [_vm._v("\n                VOTRE MESSAGE A ÉTÉ REFUSÉ"), _c('br'), _vm._v("POUR LES RAISONS SUIVANTES :\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "id": "error-modal-content"
    }
  }, [_c('ul')]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "id": "acknowlegdeButton",
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Ok")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "warning-text"
  }, [_c('ul', [_c('li', [_vm._v("\n                Nous vous informons que tout message non conforme aux conditions"), _c('br'), _vm._v("d'utilisation que vous avez validées se verra automatiquement supprimé"), _c('br'), _vm._v("et sa diffusion annulée.\n              ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "warning-text"
  }, [_c('ul', [_c('li', [_vm._v("\n                Nous vous informons que tout message non conforme aux conditions"), _c('br'), _vm._v("d'utilisation que vous avez validées se verra automatiquement supprimé"), _c('br'), _vm._v("et sa diffusion annulée.\n              ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-text-main-home"
  }, [_vm._v("\n            Pensez à vérifier que le texte de votre annonce est complet et bien lisible,"), _c('br'), _vm._v("et pensez bien qu'elle sera diffusée 6 secondes à chaque passage !\n          ")])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6222687b", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6222687b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 196
// module chunks = 1